import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BuscarService } from 'src/app/services/buscar.service';
import { alertaConfirmacion, alertaConfirmacionHTML, basicAlert, basicAlertHTML, filtrarCoincidenciaArrayTransportista, obtenerFechaActual, obtenerFechaSeleccionada, openDescripcion, openObservacion, openReutilizar, setConfigTable, setConfigTableBuscador, timerOut } from 'src/app/shared/utils';
import { ArticuloService } from 'src/app/services/articulo.service'
import { SpinnerService } from 'src/app/services/spinner.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalBusquedaProveedorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proveedor/modal-busqueda-proveedor.component'
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { iArticulo } from 'src/app/models/iarticulomodel'
import { ArticuloModel } from 'src/app/models/articulo.model'
import { objArticulo } from 'src/app/models/objarticulo.model'
import { ProveedorService } from 'src/app/services/proveedor.service'
import { UnidadService } from 'src/app/services/unidad.service';
import { RecursosService } from 'src/app/services/recursos.service';
import { isNumber } from 'util';
import { ToastrService } from 'ngx-toastr';
import {MdGenerarCodigoArtComponent} from 'src/app/shared/modals/md-generar-codigo-art/md-generar-codigo-art.component'
import { inventariosService } from 'src/app/services/inventarios.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-nuevo-articulo',
  templateUrl: './nuevo-articulo.component.html',
  styleUrls: ['./nuevo-articulo.component.css']
})
export class NuevoArticuloComponent implements OnInit {


  //VARIABLES TIPO DE INVENTARIO 
  public tiposInventario: any[] = [];
  public codTipoInventario: number = 1;

  //VARIABLES UNIDAD DE MEDIDA
  public unidadesMedidas: any[] = [];
  public codUnidadMedida: number;

  //VARIABLES CONTROL DE STOCK
  public tipoControlStock: any[] = [];

  // VARIABLES DEL FORMULARIO

  public desControlStock: string = 'Controla stock unidades';
  public inputAgrupa: boolean;
  public inputPagoAdelantado: boolean;

  //Articulo
  public objarticulo = new objArticulo()
  public desProveedor: String = ''

  //BANDERA PARA INSERTAR 

  public insertbandera = false;
  /*******MODAL INTERLOCUTOR******/

  disabledProveedor: boolean = false;
  buscarProveedor: string = 'buscar';


  @ViewChild('razon') razon: ElementRef;
  @ViewChild('plazaentrega') plazaentrega: ElementRef;
  @ViewChild('codFabri') codFabri: ElementRef;
  @ViewChild('provee') provee: ElementRef;
  @ViewChild('selectTipoInventario') selectTipoInventario: ElementRef;
  @ViewChild('desarticulo') desarticulo: ElementRef;
  /******************************/

  /*******MODAL PROVEEDOR******/
  proveedores: any[] = [];
  public _recursos: any = {};
  tipinv
  /********************************/
  constructor(
    private _buscarService: BuscarService,
    private unidadMedidaService: UnidadService,
    private articuloService: ArticuloService,
    private spinnerService: SpinnerService,
    private modalService: NgbModal,
    private provedorService: ProveedorService,
    private recursosService: RecursosService,
    private toastr: ToastrService,
    private inventariosService: inventariosService,
    private router: Router,
    private modalService2: NgbActiveModal,

  ) { }

  ngOnInit(): void {

    this.spinnerService.activarLoading(true);
    this.recursosService.recursosArticulo().subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);

      this._recursos = resp.body;

      if (this._recursos != null && this._recursos.inventarios != null)
        this.tiposInventario = this._recursos.inventarios;
      if (this._recursos != null && this._recursos.unidades != null)
        this.unidadesMedidas = this._recursos.unidades;
      if (this._recursos != null && this._recursos.controlStocks != null)
        this.tipoControlStock = this._recursos.controlStocks;

    
      this.objarticulo = new objArticulo()
      this.objarticulo.tipinv = this.tipinv
      this.objarticulo.fmatri = obtenerFechaActual('YYYY-MM-DD')
      this.objarticulo.faccon = (Number.parseFloat('1').toFixed(4));
      this.objarticulo.consto = 1;
      this.objarticulo.codprv = ''
      this.desProveedor = ''
      console.log('Si toma valor:' + this.objarticulo.fmatri)
      timerOut(5).then((value: any) => {
        if (value) { this.selectTipoInventario.nativeElement.focus(); }
      })

    }, err => {
      this.spinnerService.activarLoading(false);
    });

  }

  private getProveedores() {

    this.provedorService.buscarProveedor('', '', '', 60, 0,true).subscribe((resp: any) => {
      console.log(resp)
      console.log(resp.body);

    }, err => {

    })
  }


  asignarDecimalesFacConversion(val: any) {
    this.objarticulo.faccon = (Number.parseFloat(val).toFixed(4));
  }

  retornarEnter(e) {
    this.retornoEnter(e);
    return (this.retornoEnter(e) != 13);
  }

  retornoEnter(e) {
    let tecla: any;
    return tecla = (document.all) ? e.keyCode : e.which;
  }


  /*************INPUT CON MODAL**********/
  /**************INPUT MODAL PROVEEDOR************************/

  onKeyEnterCodProveedor(e) {
    this.onBlurCodProveedor(this.objarticulo.codprv)
  }

  onBlurCodProveedor(codpro: string) {
    console.log(codpro)
    if (codpro != '') {
      this.spinnerService.activarLoading(true);
      this.getByCodProveedor(codpro, 2);
    }
  }

  getByCodProveedor(codpro: string, tipoSearch: number) {
    this.spinnerService.activarLoading(true);
    this.provedorService.obtenerProveedor(codpro, true).subscribe((response: any) => {
      this.insertbandera = true;
      this.spinnerService.activarLoading(false);
      console.log(response)
      this.objarticulo.codprv = response.body.codcli
      this.desProveedor = response.body.razonc

      timerOut(10).then((value: any) => {
        if (value) { this.codFabri.nativeElement.focus(); }
      });

      this.disabledProveedor = true;
      this.buscarProveedor = 'borrar';
    },
      err => {
        this.insertbandera = false
        this.spinnerService.activarLoading(false);
        console.log(err);
        if (err.status == 404) {
          basicAlert('No se encontró información para el código ingresado.', 'warning', 'Aceptar');
        }

        timerOut(10).then((value: any) => {
          if (value) { this.provee.nativeElement.focus(); }
        });

        this.objarticulo.codprv = ''
        this.desProveedor = ''

      });
  }

  onKeyEnterProveedor(e) {
    this.openModalProveedor();
    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  openModalProveedor() {
    let codpro: string = '';
    let razonc: string = this.desProveedor + "%";
    let dident: string = '';
    let limit: number = 60;
    let offset: number = 0;

    console.log(razonc)

    if (this.desProveedor.length > 0) {
      this.spinnerService.activarLoading(true);
      this.provedorService.buscarProveedor(codpro, razonc, dident, limit, offset,true).subscribe((response: any) => {
        console.log(response.body);
        this.proveedores = response.body;

        this.mostrarModalProveedor();
      }, err => {
        console.log(err);
        if (err.status == 404) {
          basicAlert('No se encontró la lista de proveedores.', 'warning', 'Aceptar', null, null, this.razon);
        }
        this.spinnerService.activarLoading(false);
      });
    } else {
      basicAlert('Para activar la ayuda ingresar mínimo 1 caracter.', 'warning', 'Aceptar', null, null, this.razon);
      return;
    }
  }

  mostrarModalProveedor() {
    const referenciaModal = this.modalService.open(ModalBusquedaProveedorComponent, { scrollable: true, windowClass: 'modal-lista-articulos', backdrop: 'static' });

    referenciaModal.componentInstance.proveedores = this.proveedores;

    referenciaModal.result.then((data) => {
      console.log(data);
      this.getByCodProveedor(data.codpro, 2)
    }, (reason) => {
      console.log(reason);
    });
  }

  borrarProveedor() {

    this.objarticulo.codprv = ''
    this.desProveedor = ''

  }

  cancelar() {

    this.insertbandera = false;
    this.objarticulo.codprv = ''
    this.desProveedor = ''
    this.objarticulo = new objArticulo()
    this.objarticulo.tipinv = 1
    this.objarticulo.fmatri = obtenerFechaActual('YYYY-MM-DD')
    this.objarticulo.faccon = (Number.parseFloat('1').toFixed(4));
    this.objarticulo.consto = 1;
    this.inputPagoAdelantado = false;
    this.inputAgrupa = false;
    this.inputPagoAdelantado = false
    this.disabledProveedor = false;
    this.buscarProveedor = 'buscar';
    this.borrarDatosProveedor();
    this.tipoControlStock.forEach(element => {
      if (element.tipo == this.objarticulo.consto) {
        this.desControlStock = element.descripcion;
      }
    });

    timerOut(10).then((value: any) => {
      if (value) { this.desarticulo.nativeElement.focus(); }
    });
    this.cerrar();
  }


  borrarDatosProveedor() {
    this.borrarProveedor();

    timerOut(10).then((value: any) => {
      if (value) { this.provee.nativeElement.focus(); }
    });

    this.disabledProveedor = false;
    this.buscarProveedor = 'buscar';
  }

  /***************************************/
  /*************************TIPO DE INVENTARIO*************************************/
  onKeyEnterTipodeInventario(e) {
    if (this.objarticulo.tipinv != null) {
      setTimeout(() => {
        // this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurTipodeInventario(e) {
    if (this.objarticulo.tipinv != null) {
      if (e.which == 0) {
        //  this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
        if ($('#cboTipoInventario option:selected').text() == '') {
          this.objarticulo.tipinv = null;
        }
      }
    }
  }
  /**************************************************************/

  /*************************UNIDAD DE MEDIDA*************************************/
  onKeyEnterUnidadesMedida(e) {
    if (this.objarticulo.coduni != null) {
      setTimeout(() => {
        // this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurUnidadesMedida(e) {
    if (this.objarticulo.coduni != null) {
      if (e.which == 0) {
        //  this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
        if ($('#cboUnidadesMedida option:selected').text() == '') {
          this.objarticulo.coduni = null;
        }
      }
    }
  }
  /**************************************************************/

  //GUARDAR ARTICULO 

  guardar() {

    if (this.objarticulo.tipinv == null) {
      basicAlert('El campo tipinv es obligatorio.', 'warning', 'Aceptar', null, null, null);
      return;
    }

    if (this.objarticulo.codart == null) {
      basicAlert('El campo código es obligatorio.', 'warning', 'Aceptar', null, null, null);
      return;
    }

    if (this.objarticulo.descri == null) {
      basicAlert('El campo descripción es obligatorio.', 'warning', 'Aceptar', null, null, null);
      return;
    }

    if (this.objarticulo.coduni == null || this.objarticulo.coduni == "" || this.objarticulo.coduni == "U/M") {
      basicAlert('La unidad de medida es obligatoria.', 'warning', 'Aceptar', null, null, null);
      return;
    }

    if (this.objarticulo.faccon == undefined || this.objarticulo.faccon == null) {
      basicAlert('El factor de conversión es obligatorio y debe ser numérico.', 'warning', 'Aceptar', null, null, null);
      return;
    }

    if (isNaN(this.objarticulo.faccon)) {
      basicAlert('El factor de conversión debe ser numérico.', 'warning', 'Aceptar', null, null, null);
      return;
    } 

    if ((this.objarticulo.codprv == '') && (this.desProveedor == '')) {
      console.log('entro al if')
      this.insertbandera = true;
    }


    if (this.insertbandera == false) {
      basicAlert('El codigo del proveedor no existe.', 'warning', 'Aceptar', null, null, null);
      return;
    }



    if (this.inputAgrupa) {
      this.objarticulo.agrupa = 'S'
    } else {
      this.objarticulo.agrupa = 'N'
    }
    if (this.inputPagoAdelantado) {
      this.objarticulo.conesp = 1
    } else {
      this.objarticulo.conesp = 0
    }

    let articulodata: iArticulo = {
      id_cia: this.objarticulo.id_cia,
      tipinv: this.objarticulo.tipinv,
      codart: this.objarticulo.codart,
      descri: this.objarticulo.descri,
      codmar: this.objarticulo.codmar,
      codubi: this.objarticulo.codubi,
      codprc: this.objarticulo.codprc,
      codmod: this.objarticulo.codmod,
      modelo: this.objarticulo.modelo,
      codobs: this.objarticulo.codobs,
      coduni: this.objarticulo.coduni,
      codlin: this.objarticulo.codlin,
      codori: this.objarticulo.codori,
      codfam: this.objarticulo.codfam,
      codbar: this.objarticulo.codbar,
      parara: this.objarticulo.parara,
      proart: this.objarticulo.proart,
      codoem: this.objarticulo.codoem,
      consto: this.objarticulo.consto,
      codprv: this.objarticulo.codprv,
      agrupa: this.objarticulo.agrupa,
      fcreac: this.objarticulo.fcreac,
      fmatri: this.objarticulo.fmatri,
      factua: this.objarticulo.factua,
      usuari: this.objarticulo.usuari,
      wglosa: this.objarticulo.wglosa,
      faccon: this.objarticulo.faccon,
      tusoesp: this.objarticulo.tusoesp,
      tusoing: this.objarticulo.tusoing,
      diacmm: this.objarticulo.diacmm,
      cuenta: this.objarticulo.cuenta,
      conesp: this.objarticulo.conesp,
      linea: this.objarticulo.linea,
      proint: this.objarticulo.proint,
      codint: this.objarticulo.codint,
      codope: this.objarticulo.codope,
      situac: this.objarticulo.situac,

      stock: this.objarticulo.stock,
      precio: this.objarticulo.precio,
      codigosadd01: this.objarticulo.codigosadd01,
      codigosadd02: this.objarticulo.codigosadd02,
      clases: this.objarticulo.clases,
      clasesglobal: this.objarticulo.clasesglobal,
      imagenes: this.objarticulo.imagenes,
      codigosean: this.objarticulo.codigosean,
      especificaciones: this.objarticulo.especificaciones,
      detraccion: this.objarticulo.detraccion,

    }
    
    console.log('articuloData',articulodata);

    this.spinnerService.activarLoading(true);
    this.articuloService.insertar(articulodata).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      console.log(resp.body);
      this.toastr.success('Se registró correctamente.','',{ positionClass: 'toast-bottom-left'})
      // basicAlert('Se registró correctamente.', 'success', 'Aceptar', null, null, this.desarticulo)
      this.cerrar()
    }, err => {
      this.spinnerService.activarLoading(false);
      basicAlert(err.error, 'error', 'Aceptar', null, null, this.desarticulo)
    })
    // basicAlert('Se inserto de manera correcta.', 'success', 'Aceptar', null, null, this.desarticulo)
  }


  onNexFocus(tipo: string) {
    if (tipo == 'nuevo') {
      timerOut(10).then((value: any) => {
        if (value) { this.selectTipoInventario.nativeElement.focus(); }
      })
    }
  }
  importarDatosSunat() {
   

      // const referenciaModal = this.modalService.open(ImportarSunatComponent, { scrollable: true, backdrop: 'static' });
      // referenciaModal.componentInstance.objImageSunat = this._sunatImage;
      // referenciaModal.componentInstance.ruc = this.objProveedor.dident;
      // referenciaModal.result.then((data) => {
      //   console.log("se importo")
      //   console.log(data);

      //   this.objProveedor.codtpe = 2;
      //   this.objProveedor.tident = '06';
      //   this.objProveedor.dident = data.ruc;
      //   this.objProveedor.direc1 = data.direc;
      //   this.objProveedor.razonc = data.razonc;

      //   this.getByCodInterlocutor(this.objProveedor.dident);
      //   this.onSelectTipoIdentidadIns(this.objProveedor.tident);

        
      // let digito1 = parseInt(String(data.ruc)[0])
      // console.log("data.ruc primero");
      // console.log(digito1);

      // if(digito1 == 1){
      //   this.objProveedor.codtpe = 1;
      // }
      // if(digito1 == 2){
      //   this.objProveedor.codtpe = 2;
      // }
      // }, (reason) => {
      //   console.log("reason");
      //   console.log(reason);
      // });


    
  }
  generarCodigo(){
    
    const referenciaModal = this.modalService.open(MdGenerarCodigoArtComponent, { scrollable: true, windowClass: 'md-interlocutor', backdrop: 'static' });
    referenciaModal.componentInstance.titulo = "";
    console.log("tiívin",this.objarticulo.tipinv)
    console.log("descri",this.objarticulo.descri)
    referenciaModal.componentInstance.tipinv = this.objarticulo.tipinv;
    referenciaModal.componentInstance.descri = this.objarticulo.descri;
    referenciaModal.result.then((dato) => {
      
      if(dato.clasCod.length!=0){
        this.objarticulo.clases=dato.clasCod;
      }
      console.log('Clase Codigo',this.objarticulo.clases);
      this.inventariosService.obtenerCorrelativo(this.objarticulo.tipinv,dato.valPa).subscribe((response:any)=>{
        console.log(response.body.object);
        this.objarticulo.codart=response.body.object;
        this.toastr.success("Se registró correctamente",'',{ positionClass: 'toast-bottom-left'});
    }, err => {
      console.log(err);
      basicAlert(err.message, 'error', 'Aceptar', null, null, null)
    }); 
     }, (reason) => {
       console.log('errorga')
       console.log(reason);
      
     });
    
   }
   cerrar(){
    this.modalService2.dismiss('canceling');
  }
}
